import Training from './docsComponents/Training';

interface TrainingPageProps {
  access: any;
  baseUrl: string;
}

const TrainingPage: React.FC<TrainingPageProps> = ({ access, baseUrl }) => {
  return (
    <div className='w-full h-full overflow-hidden'>
      <Training access={access} baseUrl={baseUrl} />
    </div>
  );
};

export default TrainingPage;
